import * as React from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import User from "./User/User";
import Order from "./Order/Order";
import Messenger from "./Messenger/Messenger";
import PersonPinIcon from "@mui/icons-material/PersonPin";
import CircularImageView from "./mui/CircularImage";
import logo from "./assests/logo.png";
import Kitchen from "./Kitchen/Kitchen";
import Settings from "./Setting/Settings";
import FinanceManagement from "./Finance";
import StaffManagement from "./StaffManagement";
import { getUserType } from "./data/models/GlobalAdmin";
import VendorGifts from "./Prizes/VendorGifts";
import PrizeVendors from "./Prizes/GiftVendors";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    "aria-controls": `vertical-tabpanel-${index}`,
  };
}

export default function Home({ setAndStoreToken }) {
  const [value, setValue] = React.useState(1);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  // Original tabNames and tabPanels arrays (unused in the role-based logic)
  const tabNames = [
    "Users",
    "Vendors",
    "Finance",
    "Orders",
    "Messenger",
    "Settings",
    "Application",
  ];

  const tabPanels = [
    {
      name: "Users",
      panel: (
        <TabPanel
          style={{ width: "100%", height: window.innerHeight - 1 }}
          value={value}
          index={1}
        >
          <User />
        </TabPanel>
      ),
    },
    {
      name: "Vendors",
      panel: (
        <TabPanel
          style={{ width: "100%", height: window.innerHeight - 1 }}
          value={value}
          index={2}
        >
          <Kitchen />
        </TabPanel>
      ),
    },
    {
      name: "Finance",
      panel: (
        <TabPanel
          style={{ width: "100%", height: window.innerHeight - 1 }}
          value={value}
          index={3}
        >
          <FinanceManagement />
        </TabPanel>
      ),
    },
    {
      name: "Orders",
      panel: (
        <TabPanel
          style={{ width: "100%", height: window.innerHeight - 1 }}
          value={value}
          index={4}
        >
          <Order />
        </TabPanel>
      ),
    },
    {
      name: "Messenger",
      panel: (
        <TabPanel
          style={{ width: "100%", height: window.innerHeight - 1 }}
          value={value}
          index={5}
        >
          <Messenger />
        </TabPanel>
      ),
    },
    {
      name: "Settings",
      panel: (
        <TabPanel
          style={{ width: "100%", height: window.innerHeight - 1 }}
          value={value}
          index={6}
        >
          <Settings />
        </TabPanel>
      ),
    },
    {
      name: "Application",
      panel: (
        <TabPanel
          style={{ width: "100%", height: 650, marginBottom: 20 }}
          value={value}
          index={7}
        >
          <div style={{ height: 650 }}>
            <iframe height={650} src="https://app.nasipaipon.com"></iframe>
          </div>
        </TabPanel>
      ),
    },
  ];

  function getTabPanels() {
    const userType = getUserType();
    console.log(userType);
    
    // Define all role-specific tabs
    
    // Super Admin tabs
    const superAdmin = [
      {
        name: "Staff Management",
        panel: (
          <TabPanel
            style={{ width: "100%", height: window.innerHeight - 1 }}
            value={value}
            index={1}
          >
            <StaffManagement />
          </TabPanel>
        ),
      },
      {
        name: "Users",
        panel: (
          <TabPanel
            style={{ width: "100%", height: window.innerHeight - 1 }}
            value={value}
            index={2}
          >
            <User />
          </TabPanel>
        ),
      },
      {
        name: "Vendors",
        panel: (
          <TabPanel
            style={{ width: "100%", height: window.innerHeight - 1 }}
            value={value}
            index={3}
          >
            <Kitchen />
          </TabPanel>
        ),
      },
      {
        name: "Finance",
        panel: (
          <TabPanel
            style={{ width: "100%", height: window.innerHeight - 1 }}
            value={value}
            index={4}
          >
            <FinanceManagement />
          </TabPanel>
        ),
      },
      {
        name: "Orders",
        panel: (
          <TabPanel
            style={{ width: "100%", height: window.innerHeight - 1 }}
            value={value}
            index={5}
          >
            <Order />
          </TabPanel>
        ),
      },
      {
        name: "Prizes",
        panel: (
          <TabPanel
            style={{ width: "100%", height: window.innerHeight - 1 }}
            value={value}
            index={6}
          >
            <PrizeVendors />
          </TabPanel>
        ),
      },
      {
        name: "Messenger",
        panel: (
          <TabPanel
            style={{ width: "100%", height: window.innerHeight - 1 }}
            value={value}
            index={7}
          >
            <Messenger />
          </TabPanel>
        ),
      },
      {
        name: "Settings",
        panel: (
          <TabPanel
            style={{ width: "100%", height: window.innerHeight - 1 }}
            value={value}
            index={8}
          >
            <Settings />
          </TabPanel>
        ),
      },
    ];

    // Customer Support tabs
    const support = [
      {
        name: "Messenger",
        panel: (
          <TabPanel
            style={{ width: "100%", height: window.innerHeight - 1 }}
            value={value}
            index={1}
          >
            <Messenger />
          </TabPanel>
        ),
      },
      {
        name: "Orders",
        panel: (
          <TabPanel
            style={{ width: "100%", height: window.innerHeight - 1 }}
            value={value}
            index={2}
          >
            <Order />
          </TabPanel>
        ),
      },
      {
        name: "Users",
        panel: (
          <TabPanel
            style={{ width: "100%", height: window.innerHeight - 1 }}
            value={value}
            index={3}
          >
            <User />
          </TabPanel>
        ),
      },
    ];

    // Vendor Manager tabs
    const vendorManager = [
      {
        name: "Vendors",
        panel: (
          <TabPanel
            style={{ width: "100%", height: window.innerHeight - 1 }}
            value={value}
            index={1}
          >
            <Kitchen />
          </TabPanel>
        ),
      },
      {
        name: "Orders",
        panel: (
          <TabPanel
            style={{ width: "100%", height: window.innerHeight - 1 }}
            value={value}
            index={2}
          >
            <Order />
          </TabPanel>
        ),
      },
    ];

    // Finance Manager tabs
    const financeManager = [
      {
        name: "Finance",
        panel: (
          <TabPanel
            style={{ width: "100%", height: window.innerHeight - 1 }}
            value={value}
            index={1}
          >
            <FinanceManagement />
          </TabPanel>
        ),
      },
      {
        name: "Orders",
        panel: (
          <TabPanel
            style={{ width: "100%", height: window.innerHeight - 1 }}
            value={value}
            index={2}
          >
            <Order />
          </TabPanel>
        ),
      },
      {
        name: "Vendors",
        panel: (
          <TabPanel
            style={{ width: "100%", height: window.innerHeight - 1 }}
            value={value}
            index={3}
          >
            <Kitchen />
          </TabPanel>
        ),
      },
    ];

    // Admin tabs
    const admin = [
      {
        name: "Settings",
        panel: (
          <TabPanel
            style={{ width: "100%", height: window.innerHeight - 1 }}
            value={value}
            index={1}
          >
            <Settings />
          </TabPanel>
        ),
      },
      {
        name: "Users",
        panel: (
          <TabPanel
            style={{ width: "100%", height: window.innerHeight - 1 }}
            value={value}
            index={2}
          >
            <User />
          </TabPanel>
        ),
      },
      {
        name: "Orders",
        panel: (
          <TabPanel
            style={{ width: "100%", height: window.innerHeight - 1 }}
            value={value}
            index={3}
          >
            <Order />
          </TabPanel>
        ),
      },
      {
        name: "Messenger",
        panel: (
          <TabPanel
            style={{ width: "100%", height: window.innerHeight - 1 }}
            value={value}
            index={4}
          >
            <Messenger />
          </TabPanel>
        ),
      },
    ];

    // Return appropriate panels based on userType
    if (userType === "super_admin") {
      return superAdmin;
    }

    if (userType === "vendor_manager") {
      return vendorManager;
    }

    if (userType === "finance_manager") {
      return financeManager;
    }

    if (userType === "admin") {
      return admin;
    }
    
    if (userType === "customer_support") {
      return support;
    }

    // Default fallback
    return [];
  }

  return (
    <Box
      className="auth-bg"
      sx={{
        flexGrow: 1,
        display: "flex",
        boxShadow: "2px 2px 5px 2px rgb(0,0,0,0.2)",
        overflow: "hidden",
        flexDirection: "row",
      }}
    >
      <Tabs
        orientation="vertical"
        variant="scrollable"
        value={value}
        onChange={handleChange}
        aria-label="Vertical tabs example"
        className="h-screen"
        sx={{
          borderColor: "divider",
          backgroundColor: "rgba(0, 0, 0, 0.7)",
          width: "240px",
        }}
        TabIndicatorProps={{
          style: {
            width: "100%",
            backgroundColor: "rgba(255, 255, 255, 0.4)",
          },
        }}
      >
        <h1 className="flex flex-col text-2xl font-extrabold mt-6 text-white justify-center ">
          <h6 className=" text-center ">NASI PAIPON</h6>
          <h1 className="justify-center flex mt-6 mb-10">
            <CircularImageView imageUrl={logo} radius={120} />
          </h1>
        </h1>

        {getTabPanels().map((tab, index) => (
          <Tab
            key={index}
            disableRipple={false}
            className="hover:bg-red-600"
            label={tab.name}
            {...a11yProps(index + 1)}
            style={{
              height: 10,
              paddingBlockStart: 10,
              display: "flex",
              fontFamily: "inherit",
              alignContent: "flex-start",
              alignItems: "flex-start",
              color: "rgb(255, 255, 255)",
              fontSize: "14px",
              fontWeight: "600",
            }}
          />
        ))}

        <button
          onClick={() => {
            setAndStoreToken(null);
          }}
          className=" h-10 w-4/5 rounded-lg ml-5 font-bold absolute bottom-5"
          variant="contained"
          style={{
            color: "white",
            background: "red",
            borderRadius: "10px",
            boxShadow: "1px 1px 5px 2px rgb(0,0,0,0.2)",
          }}
        >
          LOG OUT
        </button>
      </Tabs>
      {getTabPanels().map((e) => e.panel)}
    </Box>
  );

}